import { render, staticRenderFns } from "./DictionariesBeam.vue?vue&type=template&id=2052de8a&"
import script from "./DictionariesBeam.vue?vue&type=script&lang=js&"
export * from "./DictionariesBeam.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports